import { Button, List, Spin, Typography } from 'antd';
import { Avatar, customizeRenderEmpty, InputSearch } from 'components/common';
import { useAgents } from 'hooks';
import { omniChatMessages } from 'messages';
import VirtualList from 'rc-virtual-list';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { AgentDto, UserCompactDto } from 'types';
import { includesRemoveSpecial } from 'utils';

type OmniChatSessionAgentListProps = {
  onClickItem?: (id: number, user: UserCompactDto) => void;
  className?: string;
  placeholder?: string;
  selectedUserId?: number;
};

const OmniChatSessionAgentList: React.FC<OmniChatSessionAgentListProps> = ({
  onClickItem,
  className,
  placeholder,
  selectedUserId
}) => {
  const [keyword, setKeyword] = useState('');
  const { agents, isLoading, isFetching } = useAgents(
    {},
    {
      refetchOnMountOrArgChange: true
    }
  );

  const handleSearch = (val: string) => {
    setKeyword(val);
  };

  const agentList = agents.filter((o) => includesRemoveSpecial(o.fullName, keyword));

  return (
    <div className={twMerge('flex max-h-[calc(100vh-260px)] flex-col overflow-y-auto px-4', className)}>
      <InputSearch
        className='mb-4 rounded-lg border [&>input]:!h-10'
        placeholder={placeholder ?? omniChatMessages.nameDTV}
        onChange={(e) => handleSearch(e.toString())}
        isDebounce={false}
      />
      <Spin spinning={isLoading || isFetching}>
        {agentList.length ? (
          <List className='-mx-4 max-h-[calc(100%-48px)] overflow-y-auto pb-6'>
            <VirtualList itemKey='userId' data={agentList} fullHeight>
              {(item: AgentDto) => (
                <>
                  <List.Item
                    key={item.userId}
                    className={twMerge(
                      'flex cursor-pointer items-start justify-between gap-3 border-b-0 px-5 transition-all hover:bg-colorBgIconHover'
                    )}
                  >
                    <div className='relative shrink-0'>
                      <Avatar key={item.userId} size={48} src={item.avatar} name={item.fullName} />
                    </div>
                    <div className='flex flex-1 items-start justify-between'>
                      <div className='relative flex flex-1 flex-col gap-1'>
                        <Typography.Title ellipsis level={5} className='m-0 max-w-40 leading-tight 2xl:max-w-56'>
                          {item.fullName}
                        </Typography.Title>

                        <Typography.Text className='m-0 text-sm' type='secondary'>
                          {item.totalChatSessionProcessing} {omniChatMessages.chatSession}
                        </Typography.Text>
                      </div>
                      <Button
                        onClick={() => onClickItem?.(item.userId, item)}
                        className='mt-[3px] h-8 w-[98px] rounded-lg border-mainColor1 px-3 text-xs uppercase text-mainColor1 hover:opacity-70'
                      >
                        {omniChatMessages.assign}
                      </Button>
                    </div>
                  </List.Item>
                </>
              )}
            </VirtualList>
          </List>
        ) : (
          customizeRenderEmpty()
        )}
      </Spin>
    </div>
  );
};

export default OmniChatSessionAgentList;
